var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99998 15.4294C12.5504 15.4294 15.4286 12.5512 15.4286 9.00084C15.4286 5.45043 12.5504 2.57227 8.99998 2.57227C5.44958 2.57227 2.57141 5.45043 2.57141 9.00084C2.57141 10.0292 2.81288 11.0012 3.24221 11.8632C3.3563 12.0922 3.39427 12.354 3.32813 12.6012L2.94524 14.0323C2.77902 14.6535 3.34735 15.2218 3.96856 15.0556L5.39959 14.6727C5.64679 14.6066 5.90862 14.6445 6.13768 14.7586C6.99965 15.188 7.9716 15.4294 8.99998 15.4294Z",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComment);
export default __webpack_public_path__ + "static/media/icon_comment.c26cbefd4aa0c0b5ee6297e7de55f5c2.svg";
export { ForwardRef as ReactComponent };